// Which cells of a selection a border button touches.
//
// Pure and separate from the store so it can be tested in plain node — the
// store pulls in the Giraffe SDK, which touches `window` at module load.

import type { Border, BorderEdge } from '@/model/types';

export type { Border };

/** What a border button targets. An edge is the edge of the SELECTION. */
export type BorderTarget = BorderEdge | 'all' | 'outline' | 'inside' | 'none';

/** Which edges of one cell a border target touches, given where it sits. */
export function edgesFor(
  target: BorderTarget,
  at: { r: number; c: number; r1: number; c1: number; r2: number; c2: number }
): BorderEdge[] {
  const { r, c, r1, c1, r2, c2 } = at;
  switch (target) {
    case 'all':
    case 'none':
      return ['top', 'right', 'bottom', 'left'];
    case 'outline': {
      const edges: BorderEdge[] = [];
      if (r === r1) edges.push('top');
      if (r === r2) edges.push('bottom');
      if (c === c1) edges.push('left');
      if (c === c2) edges.push('right');
      return edges;
    }
    case 'inside': {
      // The lines between cells: a bottom on every row but the last, a right on
      // every column but the last. Drawing both sides of each shared edge would
      // double its weight.
      const edges: BorderEdge[] = [];
      if (r < r2) edges.push('bottom');
      if (c < c2) edges.push('right');
      return edges;
    }
    case 'top':
      return r === r1 ? ['top'] : [];
    case 'bottom':
      return r === r2 ? ['bottom'] : [];
    case 'left':
      return c === c1 ? ['left'] : [];
    case 'right':
      return c === c2 ? ['right'] : [];
  }
}
